import React from 'react'
import { Sparkles } from 'lucide-react'
import ScreenShell from './ScreenShell'

/**
 * ComingSoonPage — shared placeholder for navigation stubs.
 *
 * Post-demo roadmap items render as real routes backed by this shell so the
 * grouped nav shows the product direction without shipping dead code. Each
 * stub carries a one-line blurb describing the eventual module; nothing here
 * calls an API or holds state.
 *
 * Item sources: docs/post-demo-backlog.md — "Verification Result Framework"
 * (module map) and the plan-25/26 deferred phases.
 */

export interface ComingSoonPageProps {
  title: string
  /** One-line description of the future module. */
  blurb: string
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ title, blurb }) => (
  <ScreenShell
    title={title}
    subtitle="Preview of a planned module"
  >
    <div className="h-full flex flex-col items-center justify-center gap-3 px-8 text-center">
      <Sparkles size={20} className="text-accent-blue" />
      <span className="text-[10px] font-semibold uppercase tracking-widest px-2 py-0.5 rounded border border-border bg-hover text-text-muted">
        Coming soon
      </span>
      <p className="max-w-md text-sm text-text-muted">{blurb}</p>
    </div>
  </ScreenShell>
)

export default React.memo(ComingSoonPage)
